<app-breadcrumb  [master]="'Analizy'" [parentName]="'OFWCA'" [name]="'Raporty'"></app-breadcrumb>
<div class="report-ofwca-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="report-ofwca-list-filters">
    <mat-form-field class="ofwca-list-filter">
      <mat-label>ID</mat-label>
      <input matInput placeholder="12345" name="recordId" [(ngModel)]="initialFilters.recordId">
    </mat-form-field>

    <mat-form-field class="report-ofwca-list-filter">
      <mat-label>Numer Profitowi</mat-label>
      <input matInput placeholder="12345" name="eq$profitNumber" [(ngModel)]="initialFilters.eq$profitNumber">
    </mat-form-field>

    <mat-form-field class="report-ofwca-list-filter">
      <mat-label>Imię</mat-label>
      <input matInput placeholder="Imię" name="contains$firstName" [(ngModel)]="initialFilters.contains$firstName">
    </mat-form-field>

    <mat-form-field class="report-ofwca-list-filter">
      <mat-label>Drugie imię</mat-label>
      <input matInput placeholder="Drugie imię" name="contains$secondName" [(ngModel)]="initialFilters.contains$secondName">
    </mat-form-field>

    <mat-form-field class="report-ofwca-list-filter">
      <mat-label>Nazwisko</mat-label>
      <input matInput placeholder="Nazwisko" name="contains$lastName" [(ngModel)]="initialFilters.contains$lastName">
    </mat-form-field>

    <mat-form-field class="report-ofwca-list-filter">
      <mat-label>PESEL</mat-label>
      <input matInput placeholder="PESEL" name="contains$pesel" [(ngModel)]="initialFilters.contains$pesel">
    </mat-form-field>

    <mat-form-field class="report-ofwca-list-filter">
      <mat-label>Numer dokumentu tożsamości</mat-label>
      <input matInput placeholder="Numer dokumentu tożsamości" name="contains$documentNumber" [(ngModel)]="initialFilters.contains$documentNumber">
    </mat-form-field>

    <mat-form-field class="report-ofwca-list-filter">
      <mat-label>Email</mat-label>
      <input matInput placeholder="Email" name="contains$email" [(ngModel)]="initialFilters.contains$email">
    </mat-form-field>

    <mat-form-field class="report-ofwca-list-filter">
      <mat-label>Numer telefonu</mat-label>
      <input matInput placeholder="Numer telefonu" name="contains$phone" [(ngModel)]="initialFilters.contains$phone">
    </mat-form-field>

    <mat-form-field class="ofwca-list-filter report-ofwca-list-filter-long">
      <mat-label>Adres</mat-label>
      <input matInput placeholder="Armii Krajowej 18, Siedlce 08-110" name="address" [(ngModel)]="initialFilters.address">
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'address_state'"
      [label]="'Województwo'" class="report-ofwca-list-filter"
      [(ngModel)]="initialFilters.state" name="state"
    ></app-dict>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true"
      [label]="'Regionalny (majątek)'"
      class="report-ofwca-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true"
      [label]="'Regionalny (życie)'" class="report-ofwca-list-filter"
      [(ngModel)]="initialFilters.lifeRegional" name="lifeRegional"
    ></app-dict-regionals>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true"
      [label]="'Regionalny (majątek) Partnera'" class="report-ofwca-list-filter report-ofwca-list-filter-long"
      [(ngModel)]="initialFilters.partnerAssetsRegional" name="partnerAssetsRegional"
    ></app-dict-regionals>

    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="report-ofwca-list-filter report-ofwca-list-filter-long"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <mat-form-field class="report-ofwca-list-filter report-ofwca-list-filter-long">
      <mat-label>Adres placówki</mat-label>
      <input matInput placeholder="Armii Krajowej 18, Siedlce 08-110" name="facilityAddress" [(ngModel)]="initialFilters.facilityAddress">
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'address_state'"
      [label]="'Województwo placówki'" class="report-ofwca-list-filter"
      [(ngModel)]="initialFilters.facilityState" name="facilityState"
    ></app-dict>

    <mat-form-field appearance="standard" class="report-ofwca-list-filter">
      <mat-label>Właściciel firmy</mat-label>
      <mat-select [(ngModel)]="initialFilters.owner" name="owner">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="report-ofwca-list-filter">
      <mat-label>Rekord zweryfikowany</mat-label>
      <mat-select [(ngModel)]="initialFilters.verified" name="verified">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <app-dict
      class="report-ofwca-list-filter" [label]="'Tagi partnera'"
      [dictType]="'partner_tags'"
      [required]="false" [multiple]="true"
      [(ngModel)]="initialFilters.partnerTag" name="partnerTag"
    ></app-dict>

    <mat-form-field class="report-ofwca-list-filter">
      <mat-label>Numer RAU</mat-label>
      <input matInput placeholder="Numer RAU" name="rauNumber" [(ngModel)]="initialFilters.rauNumber">
    </mat-form-field>

    <app-dict
      [multiple]="true" [dictType]="'ofwca_status'"
      [required]="false"
      [label]="'Status'" class="report-ofwca-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

  </form>

  <div class="report-ofwca-list-buttons">
    <button *ngIf="(userPermissions | async).analysis.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).analysis.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

</div>
